import React, { useState, useEffect } from 'react';

const SliderBlock = ({ data }) => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % data.images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [data.images.length]);

  return (
    <section className="slider">
      {data.images.map((image, index) => (
        <img
          key={index}
          src={image.src}
          alt={image.alt}
          className={`slider-image ${index === currentImage ? 'active' : ''}`}
        />
      ))}
      <div className="slider-overlay"></div>
      <div className="slider-content">
        <h1>Transform Your Business with Technology</h1>
        <p>We build cutting-edge digital solutions that drive growth and innovation</p>
      </div>
    </section>
  );
};

export default SliderBlock; 